import {Elements} from "@/types/theme";
import React from "react";
import store from "@/store";
import sortElements from "@/components/Theme/ThemeEditor/mapper/themeSort";
import getElementStatus from "./utils/getElementStatus";

type ListItemButtonProps = {
    item: Elements;
    selectedElementId?: string | null;
}

const ListItemButton = ({item, selectedElementId}:ListItemButtonProps) => {





    const handleFilePin = (item: Elements) => {
        if (store.selectedTheme) {
            const updatedItem: Elements = {...item, pinned: !item.pinned};
            store.selectedTheme.currentElements = store.selectedTheme.currentElements.map(el => el.id === item.id ? updatedItem : el);
            sortElements(null);
        }
    }



    const handleFileDelete = (item: Elements) => {
        if (store.selectedTheme) {

            const status = getElementStatus(item.id);

            if (status !== "new") {
                const deletedItem: Elements = {
                    ...item,
                    status: 'deleted',
                } ;
                store.selectedTheme.currentElements = store.selectedTheme.currentElements.map(el => el.id === item.id ? deletedItem : el);
            } else {
                store.selectedTheme.currentElements = store.selectedTheme.currentElements.filter(el => el.id !== item.id);
            }

        }
    }

    const undeleteFile = (item: Elements) => {
        const status = getElementStatus(item.id)
        const unDeletedItem: Elements = {
            ...item,
            status: status,
        } ;
        store.selectedTheme.currentElements = store.selectedTheme.currentElements.map(el => el.id === item.id ? unDeletedItem : el);
    }




    const handleFileOpen = (item: Elements) => {
        if (store.selectedTheme) {
            store.selectedTheme.selectedElementId = item.id;
        }
    }



    return (
        <li key={item.id} className="relative">
            <button
                onClick={() => {
                    handleFileOpen(item);
                }}
                className={
                    `group flex gap-x-3 rounded-md hover:pl-xs min-h-[42px] items-center text-sm leading-6 w-full justify-between transition-all `+
                    `${item.pinned ? "pl-xs": "pl-0" } `+
                    `${item?.id === selectedElementId ?
                        ' bg-gray-200 text-gray-900 text-title-md cursor-default ' +
                        `${item.status === "deleted" ? "bg-red-100 text-red-600" : "" } `
                        :
                        
                        `${item.status === "deleted" ? "bg-red-50 hover:bg-red-100" : "text-gray-700 hover:bg-gray-50 hover:text-primary-600 active:bg-gray-200" } `
                        
                    }`
                }
            >

                <span className={"flex flex-row gap-sm"}>
                    <span
                        onClick={(e)=> {
                            e.stopPropagation();
                            handleFilePin(item);
                        }}
                        className={` ${item.pinned ? "w-[32px]" : "w-[0px] group-hover:w-[32px]"} overflow-hidden font-icon-light cursor-pointer flex text-gray-500  h-[32px]  transition-all justify-center items-center hover:bg-gray-500 hover:text-white rounded-md`}
                    >
                        
                    </span>

                    <span className={
                        "flex items-center " +
                        `${item.status === "deleted" ? "line-through text-red-500 hover:text-red-500" : "" } `
                    }>
                        {item.name}
                    </span>
                    <span className="font-icon-solid text-[8px] font-normal text-black items-center flex">
                        {item.status === 'temporary' ? '' : ''}
                        {item.status === 'new' ? '' : ''}
                    </span>
                </span>
                {(!item.protected && item.status !== "deleted") &&
                    <span
                        onClick={(e)=> {
                            e.stopPropagation();
                            handleFileDelete(item);
                        }}
                        className=" absolute top-0 right-0 font-icon-light cursor-pointer opacity-0 flex text-red-500 w-[42px] h-[42px] group-hover:opacity-100 transition-all justify-center items-center hover:bg-red-500 hover:text-white rounded-md"
                    >
                        trash
                    </span>
                }

                {(item.status === "deleted") &&
                    <span
                        onClick={(e)=> {
                            e.stopPropagation();
                            undeleteFile(item);
                        }}
                        className=" absolute top-0 right-0 font-icon-light cursor-pointer opacity-0 flex text-white bg-red-500 w-[42px] h-[42px] group-hover:opacity-100 transition-all justify-center items-center hover:bg-red-200 hover:text-red-600 rounded-md"
                    >
                        
                    </span>

                }
                {item.protected &&
                    <span className=" absolute top-0 right-0 font-icon-light cursor-pointer opacity-0 flex text-gray-400 w-[42px] h-[42px] group-hover:opacity-100 transition-all justify-center items-center  rounded-md">
                        
                    </span>

                }

            </button>
        </li>
    );
};

export default ListItemButton